module.exports = __webpack_public_path__ + "static/img/SearchDetailEnterprise4.dda1519.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailEnterprise4.png
// module id = 728
// module chunks = 0